import { combineReducers, compose } from '@reduxjs/toolkit';

import slice from './cart.slice';

/** Represents the slice as it exists in the final store's reducer */
const combined = combineReducers({ [slice.name]: slice.reducer });
type GlobalState = ReturnType<typeof combined>;

/** Get the local state for the current domain */
const localState = (state: GlobalState) => state[slice.name];
type LocalState = ReturnType<typeof localState>;

const selectCart = (state: LocalState) => state.betterCart;

const selectCartPromoCode = (state: LocalState) => state.betterCart?.promo_code || null;
const selectCartGiftCert = (state: LocalState) => state.betterCart?.gift_certificate;

const selectCartStatus = (state: LocalState) => state.status;

const selectHasCartGuid = (state: LocalState) => {
  return !!state.betterCart?.guid;
};

const selectCartGuidRequired = (state: LocalState) => {
  const guid = state.betterCart?.guid;

  if (!guid) throw new Error('No Cart');

  return guid;
};

const selectCartProjectId = (state: LocalState) => state.betterCart?.cart_project_id;

const selectCartPaymentType = (state: LocalState) => state.betterCart?.payment?.payment_type;
const selectCartPaymentMethod = (state: LocalState) => state.betterCart?.payment;

export default {
  cart: compose(selectCart, localState),
  promoCode: compose(selectCartPromoCode, localState),
  giftCard: compose(selectCartGiftCert, localState),
  status: compose(selectCartStatus, localState),
  hasGuid: compose(selectHasCartGuid, localState),
  guidRequired: compose(selectCartGuidRequired, localState),
  projectId: compose(selectCartProjectId, localState),
  paymentType: compose(selectCartPaymentType, localState),
  paymentMethod: compose(selectCartPaymentMethod, localState),
};
